const transformGroups = subGroupAccess => {
  // console.log('transformGroups', subGroupAccess);
  let groups = [];
  // can a brotha get a group by?
  subGroupAccess.forEach(parent => {
    parent.groupCk = parseInt(parent.groupCk);
    parent.subGroupCk = parseInt(parent.subGroupCk);
    let group = JSON.parse(JSON.stringify(parent));
    group.subGroups = [];

    let subGroup = {
      subGroupName: parent.subGroupName,
      subGroupCk: parent.subGroupCk,
      subGroupId: parent.subGroupId,
      effectiveDate: parent.subGroupEffectiveDate,
      terminationDate: parent.subGroupTerminationDate,
      groupDetails: 'View Details',
      groupName: parent.groupName,
      groupCk: parent.groupCk,
      groupId: parent.groupId,
      access: parent.access
    };

    let idx = groups.findIndex(g => g.groupCk === parent.groupCk);
    // console.log(idx);
    if (idx === -1) {
      group.subGroups.push(subGroup);
      groups.push(group);
    } else {
      groups[idx].subGroups.push(subGroup);
    }
    // console.log(`groups`, groups);
  });
  return groups.toSorted((a, b) => a.groupName.localeCompare(b.groupName));
};

const transformSearchGroups = searchGroups => {
  // console.log('transformSearchGroups', searchGroups);
  const xformed = [];
  if (searchGroups && searchGroups.length > 0) {
    searchGroups.forEach(parentGroup => {
      let group = JSON.parse(JSON.stringify(parentGroup));
      delete group.accountManagerEmail;
      delete group.accountManagerFax;
      delete group.accountManagerName;
      delete group.accountManagerPhone;
      delete group.effectiveDate;
      delete group.terminationDate;
      delete group.groupAlias;
      group.groupEffectiveDate = '';
      group.groupTerminationDate = '';

      if (group.subGroups && group.subGroups.length > 0) {
        group.subGroups.forEach(sg => {
          group.subGroupCk = sg.subGroupCk;
          group.subGroupId = sg.subGroupId;
          group.subGroupName = sg.subGroupName;
          group.subGroupEffectiveDate = sg.effectiveDate;
        });
      }

      xformed.push(group);
    });
  }
  return xformed.toSorted((a, b) => a.groupName.localeCompare(b.groupName));
};

export default {
  CLEAR_ACTIVE_USER(state) {
    state.activeUser = {};
    state.accountTypeOptions = [];
    state.accountTypeRelations = [];
    state.cloneAcls = [];
    state.groupToAddTo = [];
    state.groupsToAdd = [];
  },
  CLEAR_GROUP_TO_ADD_TO(state) {
    state.groupToAddTo = [];
  },
  CLEAR_GROUPS_TO_ADD(state) {
    state.groupToAddTo = [];
  },
  CLEAR_SEARCH_GROUPS(state) {
    state.searchGroups = [];
  },
  CLEAR_USER_IDS_TO_BE_ADDED(state) {
    state.userIdsToBeAdded = [];
  },
  CREATE_NEW_USER(state) {
    state.activeUser = JSON.parse(JSON.stringify(state.blankUser));
  },
  SET_ACCOUNT_TYPE_OPTIONS(state, options) {
    state.accountTypeOptions = options;
  },
  SET_ACCOUNT_TYPE_RELATIONS(state, relations) {
    state.accountTypeRelations = relations;
  },
  SET_ACTIVE_USER(state, user) {
    state.activeUser = {};
    if (user.role && user.role.subGroupAccess) {
      // console.log(`SET_ACTIVE_USER`, user);
      let groups = transformGroups(user.role.subGroupAccess);
      let pendingGroups = transformGroups(user.role.subGroupAccessPending);
      // console.log(`SET_ACTIVE_USER post xform`, pendingGroups);
      user.role.groupsWithSubGroups = groups;
      user.role.pendingGroupsWithSubGroups = pendingGroups;
    }
    state.activeUser = user;
  },
  SET_ACTIVE_USER_ACLS(state, acls) {
    state.activeUser.role.subGroupAccess = [...acls];
  },
  SET_ACTIVE_USER_HISTORY(state, history) {
    state.activeUser.transactionHistory = history;
    state.transactionHistory = history;
  },
  SET_ACTIVE_USER_ROLE(state, role) {
    state.activeUser.role = {};
    if (role && role.subGroupAccess) {
      let subGroupAccess = role.subGroupAccess;
      let groups = transformGroups(subGroupAccess);
      let pendingGroups = transformGroups(
        role.subGroupAccessPending
      ).sort((a, b) => a.groupName.localeCompare(b.groupName));
      groups = groups.sort((a, b) => a.groupName.localeCompare(b.groupName));
      // console.log(`SET_ACTIVE_USER_ROLE`, pendingGroups);
      role.groupsWithSubGroups = groups;
      role.pendingGroupsWithSubGroups = pendingGroups;
    }
    state.activeUser.role = role;
  },
  SET_CLONE_ACLS(state, newAcls) {
    state.cloneAcls = [...newAcls];
  },
  SET_GROUP_TO_ADD_USERS_TO(state, group) {
    state.groupToAddUsersTo = group;
  },
  SET_GROUP_TO_ADD_TO(state, group) {
    state.groupToAddTo = group;
  },
  SET_GROUPS_TO_ADD(state, groups) {
    state.groupsToAdd = groups;
  },
  SET_HISTORY_LOADING(state, loading) {
    state.historyLoading = loading;
  },
  SET_SEARCH_GROUPS(state, opts) {
    if (opts.isInternal) {
      state.searchGroups = transformSearchGroups(opts.groups);
    } else {
      state.searchGroups = transformGroups(opts.groups);
    }
  },
  SET_USER_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_USER_IDS_TO_BE_ADDED(state, userIdsToBeAdded) {
    state.userIdsToBeAdded = userIdsToBeAdded;
  }
};
